import { ajaxModalCall } from './_ajaxModalCall';
import { customCheckBox } from '../global/_customCheckBox';
import { preventDoubleClick } from '../global/_doubleClick';
import { allDevicesDeclineGift } from '../checkout/_declineGift';

// const giftRowClick = () => {
//     $('.giftrow').on('click', function() {
//         if ($('.nogift').find('input').prop('checked')) $('.nogift').find('input').prop('checked',false);
//         let giftChoice = $(this).find('.giftchoice input');
//         giftChoice.prop('checked',giftChoice.is('input[type="radio"]') || !giftChoice.prop('checked'));
//         giftChoice.trigger('change');
//     });
// }

const clickToZoomGWPThumbnailImage = () => {
	$('.modal .gwp-pwp-table .gwp-pwp-image').on('click', function () {
		var imgSrc = $(this).attr('src');
		$('.modal .gwp-pwp-zoomed-image-wrapper .gwp-pwp-zoomed-figure .gwp-pwp-zoomed-image').attr('src', imgSrc);
		$('.modal .gwp-pwp-table,.modal .gwp-pwp-footer,.modal .modal-title, #declineGift').hide();
		$('.modal .gwp-pwp-zoomed-image-wrapper').show();
	});

	$('.btn-zoomed-back').on('click', function () {
		$('.modal .gwp-pwp-table,.modal .gwp-pwp-footer,.modal .modal-title, #declineGift').show();
		$('.modal .gwp-pwp-zoomed-image-wrapper').hide();
		$('.modal .gwp-pwp-zoomed-image-wrapper .gwp-pwp-zoomed-figure .gwp-pwp-zoomed-image').attr('src', '');
	});
};

export const callPickYourFreeGiftView = (params, returnHTML) => {
	var myCallback = function () {
			customCheckBox();
			allDevicesDeclineGift();
			preventDoubleClick();
			clickToZoomGWPThumbnailImage();
			//giftRowClick();
		},
		url = '/webapp/wcs/stores/servlet/PickYourFreeGiftView',
		data =
//			'maxAvailableItems=' +
//			params.maxAvailableItems +
			'&rewardOptionID=' +
			params.rewardOptionID +
			'&orderId=' +
			params.orderId +
			'&langId=' +
			params.langId +
			'&storeId=' +
			params.storeId +
			'&catalogId=' +
			params.catalogId +
			'&rewardType=' +
			params.rewardType +
			'&selectionMade=' +
			params.selectionMade;
;
	$.ajax({
		url: url,
		cache: false,
		type: 'POST',
		data: data,
		success: function (html) {
			returnHTML(html, myCallback);
			return false;
		},
	});
};
